


































































































































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Message from '@/domain/message/message';
import MainButton from '@/shared/buttons/main-button.component.vue';
import MessageHandler from '@/domain/message/message-handler';
import ModalWarning from '@/shared/modal/modal-warning.component.vue';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import { VbLoadingService } from '@/shared/loading/loading.service';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import ContractRuleRequest from '@/domain/contract/request/contract-rule-request';
import UserBusinessUnitService from '@/domain/business-unit/service/business-unit.store';
import TaskService from '@/domain/task/task.service';
import Task from '@/domain/task/task.entity';
import AuthorityService from '@/domain/security/authority.service';
import RuleGroupService from '@/domain/scripts/service/rule-group.service';
import Rule from '@/domain/rule/entity/rule.entity';
import RuleService from '@/domain/rule/service/rule.service';
import EventBus, { Event } from '@/event.bus';
import BusinessUnit from '@/domain/business-unit/entity/business-unit.entity';
import ContractService from '@/domain/contract/service/contract.service';
import ContractItemRule from '@/domain/contract/entity/contract-item-rule.entity';
import CalculationService from '@/domain/calculation/service/calculation.service';
import CalculationResult from '@/domain/calculation/entity/calculation-result.entity';
import RuleGroup from '@/domain/scripts/entity/rule-group.entity';
import RuleGroupResponse from '@/domain/scripts/entity/rule-group-response';
import RuleGroupItem from '@/domain/scripts/entity/rule-group-item.entity';
import RuleParameters from '@/domain/rule/entity/rule-parameters.entity';
import ContractRule from '@/domain/contract/entity/contract-rule.entity';
import PerformBillingModal from '@/views/contract/contract-info/itens/perform-billing/perform-billing-modal.component.vue';
import UserProfile from '@/domain/access/domain/profile.enum';
import ContractItemRuleContent from './contract-info-content.component.vue';
import CalculationEditionRules from './manage-calculation-edition.component.vue';
import CalculationEditionParameters from './manage-calculation-parameters.component.vue';
import ConfigurationModal from './alias-modal.component.vue';

@Component({
  components: {
    MainButton,
    ContractItemRuleContent,
    CalculationEditionRules,
    CalculationEditionParameters,
    ModalWarning,
    VbTooltipSlot,
    ConfigurationModal,
    PerformBillingModal,
  },
})
export default class ManageCalculation extends Vue {
  @Prop({ type: Boolean, default: false })
  billingDaily!: boolean;

  businessUnitId: string = '';

  contractItemRule: ContractItemRule = ContractItemRule.of({});

  ref: any = this.$refs;

  editModeValue: boolean = false;

  warningModal: boolean = false;

  warningMessage = 'Deseja realmente prosseguir? Ao clicar no botão Sim, as alterações serão imediatamente descartadas.';

  componentIsFullyMounted: boolean = false;

  simulateModal: boolean = false;

  calculationResult: CalculationResult = CalculationResult.of({});

  calculationId: string = '';

  rulesKey: number = 0;

  parametersKey: number = 10;

  isSimulating: boolean = false;

  showConfiguration: boolean = false;

  userLoggedInAuthorities!: string[];

  isAdministrator: boolean = false;

  profile: string = '';

  restrictRulesProfile: Rule[] = [];

  ruleGroupList: RuleGroup[] = [];

  ruleGroupContract: RuleGroup = RuleGroup.of({});

  internalRules: Rule[] = [];

  contractItemReviewed: boolean = false;

  showReviewedContractItem: boolean = false;

  reviewedContractItemMessage: string = 'Deseja realmente prosseguir? Ao confirmar, o item entrará no fluxo de aprovado e não poderá ser desmarcado.';

  enableRevisionFlow: boolean = false;

  get hasPermission(): boolean {
    return this.isAdministratorOrSupervisor || this.profile === UserProfile.GP;
  }

  get isAdministratorOrSupervisor(): boolean {
    return this.isAdministrator || this.profile === UserProfile.SUPERVISOR;
  }

  handleExecutionSuccess() {
    this.simulateModal = true;
  }

  handleExecutionError() {
  }

  updateSimulateModalState(value: boolean) {
    this.simulateModal = value;
    if (value) {
      this.resetModalObject();
    }
  }

  rerenderComponents() {
    this.rulesKey += 1;
    this.parametersKey += 1;
  }

  resetContractItemRuleObject() {
    this.contractItemRule = ContractItemRule.of({});
  }

  confirmWarning() {
    this.warningModal = false;
    this.editModeValue = false;
    this.resetContractItemRuleObject();
    this.getContractItemRules();
    this.getRestrictRulesPerProfile();
    this.getRuleGroupBusinessUnit();
    this.getRuleGroupContractId();
    this.rerenderComponents();
  }

  cancelWarning() {
    this.warningModal = false;
  }

  changedCompetence(): void {
    this.resetModalObject();
  }

  resetModalObject(): void {
    this.calculationResult = CalculationResult.of({});
  }

  loadAfterCreated() {
    this.getUserLoggedInAuthorities();
    this.getContractItemRules();
    this.getRestrictRulesPerProfile();
    this.getRuleGroupBusinessUnit();
    this.getRuleGroupContractId();
  }

  created() {
    this.businessUnitId = UserBusinessUnitService.currentBusinessUnit.id;
    this.profile = UserBusinessUnitService.currentBusinessUnit.profile;
    this.contractItemReviewed = (this.$route.params.reviewed === 'S');
    this.enableRevisionFlow = UserBusinessUnitService.currentBusinessUnit.enableRevisionFlow;
    EventBus.$on(Event.BUSINESS_UNIT_SELECTED, (businessUnit: BusinessUnit) => {
      if (this.$route.name && this.$route.name.includes('Contrato')) {
        this.businessUnitId = businessUnit.id;
        this.profile = businessUnit.profile;
        this.getContractItemRules();
        this.getRuleGroupBusinessUnit();
        this.getRuleGroupContractId();
        this.contractItemReviewed = (this.$route.params.reviewed === 'S');
        this.enableRevisionFlow = UserBusinessUnitService.currentBusinessUnit.enableRevisionFlow;
      }
    });
    this.loadRules();
    setTimeout(() => { this.loadAfterCreated() }, 1 * 1000);
  }

  mounted() {
    this.componentIsFullyMounted = true;
  }

  loadRules() {
    RuleService.getRules().then((response: Rule[]) => {
      this.internalRules = response;
    }).catch((err: any) => VbSnackbarService.handleHttpError(err));
  }

  getContractItemRules() {
    if (this.$route.params.id && this.businessUnitId) {
      ContractService.getContractItemRules(this.businessUnitId, this.$route.params.id)
        .then((response: ContractItemRule) => {
          this.contractItemRule = response;
        })
        .catch((err: any) => VbSnackbarService.handleHttpError(err));
    }
  }

  getRuleGroupBusinessUnit() {
    if (this.$route.params.id && this.businessUnitId) {
      RuleGroupService.getAll(this.businessUnitId)
        .then((response: RuleGroupResponse[]) => {
          this.ruleGroupList = RuleGroup.ofList(response);
        })
        .catch((err: any) => VbSnackbarService.handleHttpError(err));
    }
  }

  getRuleGroupContractId() {
    if (this.contractItemRule.ruleGroupId === '') {
      return;
    }
    RuleGroupService.getRuleGroupByContractItemId(this.businessUnitId, this.$route.params.id)
      .then((response: RuleGroupResponse) => {
        this.ruleGroupContract = RuleGroup.of(response);
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err));
  }

  validate() {
    const editionValid = this.ref.editionForm.$refs.form.validate();
    const parametersValid = this.ref.parametersForm.$refs.form.validate();
    if (editionValid && parametersValid) {
      this.persistContractItemRules();
    }
  }

  get tooltipInvalidSimulateButton(): string {
    if (this.contractItemRule.rules[0].isEmpty()) {
      return 'É necessário ter ao menos um cálculo para realizar a simulação';
    }
    return 'Não é possível simular o faturamento enquanto edições estiverem sendo feitas';
  }

  get tooltipContractItemReviewed(): string {
    if (this.contractItemReviewed) {
      return 'Item do contrato foi verificado'
    }
    return 'Fluxo para confirmação de verificação do item do contrato. Quando confirmado um e-mail é disparado notificando os interessados'
  }

  get isValid(): boolean {
    if (!this.componentIsFullyMounted) return false;
    return this.ref.editionForm.$refs.form.validate()
      && this.ref.parametersForm.$refs.form.validate()
      && !this.editModeValue
      && !this.contractItemRule.rules[0].isEmpty();
  }

  simulateCalculation(competence: string): void {
    this.isSimulating = true;
    CalculationService
      .simulate(this.businessUnitId, this.contractItemRule.id, competence)
      .then((response: any) => this.handleSimulationSuccess(response))
      .catch((err: any) => this.handleSimulationError(err));
  }

  private handleSimulationSuccess(taskId: string) {
    TaskService.getTask(taskId, 2000)
      .then((task: Task) => {
        this.calculationResult = CalculationResult.of(task.payload);
        this.isSimulating = false;
      })
      .catch((err) => this.handleSimulationError(err))
  }

  private handleSimulationError(err: any) {
    this.isSimulating = false;
    VbSnackbarService.handleHttpError(err);
  }

  handleMessage(message: Message) {
    MessageHandler.handle(message, this.calculationId)
      .then(() => this.calculationResult = CalculationResult.of(message.payload))
  }

  persistContractItemRules() {
    if (this.contractItemRule.ruleGroupId !== '') {
      const ruleGroupId = this.contractItemRule.ruleGroupId;
      this.contractItemRule.rules.forEach((el: ContractRule) => el.ruleGroupId = ruleGroupId)
    }
    const contractRules = ContractRuleRequest.ofList(this.contractItemRule.rules)
    ContractService.persistRules(this.businessUnitId,
      this.$route.params.id, contractRules)
      .then(() => {
        VbSnackbarService.showSuccess('Parametrização de cálculo efetuada com sucesso');
        this.editModeValue = false;
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
  }

  back() {
    this.$router.back();
  }

  get editMode(): object {
    return {
      color: this.editModeValue ? 'lightGreen' : 'lightBlue',
      text: this.editModeValue ? 'Editando' : 'Editar',
      icon: !this.editModeValue,
    }
  }

  getUserLoggedInAuthorities() {
    AuthorityService.authorities().then((resp) => {
      this.userLoggedInAuthorities = resp;
      this.isAdministrator = this.userLoggedInAuthorities.includes('ADMINISTRATOR');
    })
  }

  getRestrictRulesPerProfile() {
    if (!this.profile || !this.businessUnitId) return;
    RuleService.getRestrictRulesPerProfile(this.businessUnitId, this.profile)
      .then((response: Rule[]) => this.restrictRulesProfile = response)
      .catch((err: any) => VbSnackbarService.handleHttpError(err));
  }

  addRuleGroupContractItemRule(ruleGroup: RuleGroup) {
    this.contractItemRule.ruleGroupId = ruleGroup.id;
    ruleGroup.rules.forEach((el: RuleGroupItem) => {
      const indexRule = this.internalRules.findIndex((ruleItem: Rule) => ruleItem.id === el.id);

      const ruleGroupSelected = this.internalRules[indexRule];
      this.contractItemRule.addNewRule();
      const index = this.contractItemRule.rules.length - 1;
      ruleGroupSelected.parameters = RuleParameters.ofList(el.parameters);
      this.contractItemRule.updateRules(ruleGroupSelected, index);
    });
  }

  handleConfirmReviewedContractItem() {
    if (this.contractItemReviewed === true) {
      return
    }
    this.showReviewedContractItem = false;
    ContractService.reviewedContractItem(this.businessUnitId, this.$route.params.id)
      .then(() => {
        VbSnackbarService.showSuccess('Aprovação efetuada com sucesso');
        this.contractItemReviewed = true;
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
  }

  handleCancelReviewedContractItem() {
    this.showReviewedContractItem = false;
  }
}
